"use strict";

const constval = require("./constval");

/*
 日付を生成
 引　数：日付, 加算減算日数
 戻り値：年月日（2020-01-01）
*/
export function getDate(d: string, format: string, num: number = null) {
    let dt = new Date(d);
    if ( num ) {
        dt.setDate(dt.getDate() + num);
    }
    format = format.replace(/YYYY/, String(dt.getFullYear()));
    format = format.replace(/MM/, String((dt.getMonth() + 1).toString().padStart(2, '0')));
    format = format.replace(/DD/, String(dt.getDate().toString().padStart(2, '0')));
    return format;
}

// 郵便番号形式チェック
export function checkZipCode(zipcode: string) {
    let pattern = /^[0-9]{3}-[0-9]{4}$/;
    let zip_check = pattern.test(zipcode)
    if ( zipcode ) {
        if ( zip_check === false ) {
            return false;
        }
    }
    return true;
}

// カート数量取得処理
export function getCartCount() {
    $.ajax({
        url: "/cart_count",
        type: "GET",
        dataType: "json",
        timeout: constval.AJAX_TIMEOUT.MS,
    }).done(function(data) {
        if (data.result) {
            // メニューのバッジを更新
            $("#cart_badge").remove();
            if (data.cart_sum !== null && data.cart_sum !== undefined) {
                $(".menu_cart").append("<span id='cart_badge'>" + data.cart_sum + "</span>");
                $(".menu_cart").addClass("cartCount");
            } else {
                $(".menu_cart").removeClass("cartCount");
            }
        }
    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        showAlertMessage("カートの情報を取得出来ませんでした。")
    })
}

// Toast
export const showAlertMessage = (message: string): void => {
    const icon = '<i class="material-icons small">error_outline</i>';
    M.toast({
        html: icon + message +
            `<a class="toastCloseLink" onclick='M.Toast.getInstance(this.parentElement).dismiss();'>
                閉じる
            </a>`,
        classes: "alertToast",
    })
}
export const showAlertMessageBeforeReload = (message: string, href: string): void => {
    const transition = () => window.location.href = href
    setTimeout(transition, 3000)

    const icon = '<i class="material-icons small">error_outline</i>';
    M.toast({
        html: icon + message +
            `<a class="toastCloseLink" onclick='M.Toast.getInstance(this.parentElement).dismiss();'>
                閉じる
            </a>`,
        classes: "alertToast",
        completeCallback: transition,
    })
}
export const showInfoMessage = (message: string): void => {
    const icon = '<i class="material-icons small">check</i>';
    M.toast({
        html: icon + message +
            `<a class="toastCloseLink" onclick='M.Toast.getInstance(this.parentElement).dismiss();'>
                閉じる
            </a>`,
        classes: "infoToast",
    })
}
export const showInfoMessageBeforeReload = (message: string, href: string): void => {
    const transition = () => window.location.href = href
    setTimeout(transition, 3000)

    const icon = '<i class="material-icons small">check</i>';
    M.toast({
        html: icon + message +
            `<a class="toastCloseLink" onclick='M.Toast.getInstance(this.parentElement).dismiss();'>
                閉じる
            </a>`,
        classes: "infoToast",
        completeCallback: transition,
    })
}

export const showInfoMessageLogout = (message: string): void => {
    M.toast({
        html:
        `<a class="logoutToast" onclick='M.Toast.getInstance(this.parentElement).dismiss();'>`
        + message +
        `</a>`,
        classes: "logoutToast",
    })
}

export const showInfoMessageCount = (message: string): void => {
    M.toast({
        html:
        `<a class="logoutToast" onclick='M.Toast.getInstance(this.parentElement).dismiss();'>`
        + message +
        `</a>`,
        classes: "countToast",
    })
}

// 桁数制御
export function checkLength(value:any): boolean {
    const maxLength = 5
    if (value === undefined || value === null || value === "") {
        return false;
    } else {
        const length = value.toString().length;
        if (maxLength <= length){
            return true
        }
        return false;
    }
}

// ダウンロードリンク押下で一定時間リンクを無効化
export function clickDownloadLink(e) {
    let link = $(e.target).closest('a');
    link.attr('disabled', 'disabled');
    setTimeout(function() {
        link.attr('disabled', null);
    }, 1000);
}

